import React, { PureComponent } from 'react';

// Components
import styles from './drag-overlay.scss';

interface DragOverlayProps {
  show: boolean;
  onDragEnd?: (e: MouseEvent) => void;
}
export default class DragOverlay extends PureComponent<DragOverlayProps> {
  added: false;
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.el.classList.add(styles.root);
    this.el.addEventListener('mouseup', this.handleEnd);
    this.el.addEventListener('mouseleave', this.handleEnd);
  }

  componentDidMount() {
    this.update();
  }
  componentDidUpdate() {
    this.update();
  }

  componentWillUnmount() {
    this.remove();
  }

  update() {
    if (this.props.show) {
      this.add();
    } else {
      this.remove();
    }
  }

  add() {
    if (!this.added) {
      this.added = true;
      document.body.appendChild(this.el);
    }
  }

  remove() {
    this.el.remove();
  }

  handleEnd = e => {
    if (this.props.onDragEnd) this.props.onDragEnd(e);
  };

  render() {
    return false;
  }
}
